import flagsmith from "flagsmith"
import { useEffect, useState } from "react"
import { createContainer } from "unstated-next"

import { FLAGSMITH_ENV_ID } from "../constant/envVariables"
import { Account } from "../module/account"

interface OnChangeProps {
    features: Record<FeatureFlag, boolean> | {}
    values: Record<FeatureFlag, any> | {}
}

interface FeatureToggleState {
    isLoading: boolean
    features: { [key in FeatureFlag]?: boolean }
    values: { [key in FeatureFlag]?: any }
}

export enum FeatureFlag {}

export const FeatureToggleContainer = createContainer(useFeatureToggle)

function useFeatureToggle() {
    const { account } = Account.useContainer()
    const [state, setState] = useState<FeatureToggleState>({
        isLoading: true,
        features: {},
        values: {},
    })
    useEffect(() => {
        if (!FLAGSMITH_ENV_ID) {
            setState(prev => ({ ...prev, isLoading: false }))
            return
        }
        flagsmith.init({
            environmentID: FLAGSMITH_ENV_ID,
            onChange: () => {
                const { features, values } = Object.values(FeatureFlag).reduce(
                    ({ features, values }, flag): OnChangeProps => {
                        return {
                            features: { ...features, [flag]: flagsmith.hasFeature(flag) },
                            values: { ...values, [flag]: flagsmith.getValue(flag) || null },
                        }
                    },
                    {
                        features: {},
                        values: {},
                    },
                )

                setState({
                    isLoading: false,
                    features,
                    values,
                })
            },
        })
    }, [])

    useEffect(() => {
        if (!account) {
            return
        }
        flagsmith.identify(account)
        return () => {
            flagsmith.logout()
        }
    }, [account])

    return {
        ...state,
    }
}
